import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  Box,
  Stack,
  Container,
  Button,
  AppBar,
  Toolbar,
  Menu,
  MenuItem,
  Avatar,
  Tooltip,
  Typography,
  IconButton,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import RateReviewIcon from '@mui/icons-material/RateReview';
import { ReactComponent as ManageIcon } from "./assets/Settings-Motion-Mode--Streamline-Rounded-Material-Symbols.svg";
import { ReactComponent as LogoutIcon } from "./assets/Logout-1--Streamline-Ultimate.svg";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { ReactComponent as LogoWhiteIcon } from "./assets/logo_white.svg";
import { keycloak } from "./config/auth";
import { BASENAME } from "./config/settings";
import { USER_ACTIONS, isAllowedAction } from "./config/auth";

function MainNavigation() {
  const navigate = useNavigate(); // This will now work because it's within the Router context
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const isAuth = keycloak?.authenticated || false;

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const allPages = [
    {
      label: "Manage",
      icon: <ManageIcon className="top-nav-icon" />,
      path: "/management",
      requiredPermission: [
        USER_ACTIONS.UPDATE_OWN_FORM,
        USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY,
        USER_ACTIONS.VIEW_PARTICIPANT_REGISTRY,
        USER_ACTIONS.UPDATE_OWN_CONNECTOR,
      ],
    },
    {
      label: "Messages",
      icon: <RateReviewIcon className="top-nav-icon" style={{fontSize: "2.35em"}} />,
      path: "/messages",
      requiredPermission: [
        USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY,
      ],
    },
  ];

  const pages = allPages.filter(
    (page) =>
      isAuth &&
      page.requiredPermission.some((permission) =>
        isAllowedAction(permission)
      )
  );

  return (
    <AppBar position="static" className="top_navigation">
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ justifyContent: "space-between" }}>
          {/* Mobile Navigation */}
          <Box sx={{ flexGrow: 0 }}>
            <Link to="/">
              <LogoWhiteIcon
                style={{
                  width: "18%",
                  height: "15%",
                  paddingTop: "0.5em",
                  paddingBottom: "0.5em",
                  marginRight: "2em",
                  cursor: "pointer",
                }}
              />
            </Link>
          </Box>
          {isAuth && (
            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                className="grey-background-mobile"
                sx={{ display: { xs: "block", md: "none" } }}
              >
                {pages.map((page) => (
                  <MenuItem
                    key={page.label}
                    onClick={() => {
                      navigate(page.path);
                      handleCloseNavMenu();
                    }}
                    className="grey-background-mobile"
                  >
                    <ListItemIcon>{page.icon}</ListItemIcon>
                    <ListItemText
                      sx={{
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#fff",
                      }}
                    >
                      {page.label}
                    </ListItemText>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          )}
          {/* Desktop Navigation */}
          {isAuth && (
            <Box
              sx={{
                marginRight: "2em",
                flexGrow: 1,
                gap: "1em",
                display: { xs: "none", md: "flex" },
              }}
            >
              {pages.map((page) => (
                <Button
                  key={page.label}
                  onClick={() => {
                    navigate(page.path);
                    handleCloseNavMenu();
                  }}
                  sx={{ my: 2, color: "white", display: "block" }}
                  startIcon={page.icon}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: "400",
                      textTransform: "none",
                      color: "#fff",
                    }}
                  >
                    {page.label}
                  </Typography>
                </Button>
              ))}
            </Box>
          )}

          {isAuth && (
            <Box sx={{ flexGrow: 0 }}>
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar sx={{ bgcolor: "#cdd5df" }}>
                  <AccountCircle />
                </Avatar>
              </IconButton>
              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                <MenuItem
                  onClick={() => {
                    var base_url = window.location.origin + BASENAME + "/";
                    keycloak.logout({ redirectUri: base_url });
                  }}
                >
                  <ListItemIcon>
                    <LogoutIcon style={{ width: "32px" }} />
                  </ListItemIcon>
                  <ListItemText sx={{ paddingLeft: "1em" }}>
                    Logout
                  </ListItemText>
                </MenuItem>
              </Menu>
            </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default MainNavigation;
